<template>
  <div>
    <transition name="screen" mode="out-in">
      <OfferOptionsScreen v-if="activeFinalisingTradeScreen == 'OFFER_OPTIONS_SCREEN'" />
      <OfferQuestionScreen v-else-if="activeFinalisingTradeScreen == 'TRADE_MCQ_SCREEN'" />
      <TradeCongratulatoryScreen v-else-if="activeFinalisingTradeScreen == 'TRADE_CONGRATULATORY_SCREEN'" />
    </transition>
  </div>
</template>

<script setup lang="ts">
import OfferOptionsScreen from '@/components/screens/game-play/finalising-trade/OfferOptionsScreen.vue'
import OfferQuestionScreen from '@/components/screens/game-play/finalising-trade/OfferQuestionScreen.vue'
import TradeCongratulatoryScreen from '@/components/screens/game-play/finalising-trade/TradeCongratulatoryScreen.vue'
import { useGameArea } from '@/composables/useGameArea'

const { activeFinalisingTradeScreen } = useGameArea()
</script>
